/**
 * The crisis resource rows, in display order. Both the server AgentScreen spec
 * and the mobile co-bundled tool-surface document build their ResourceCard rows
 * from this list, so the two surfaces cannot drift in icons, tones, or order.
 *
 * `labelKey` / `descriptionKey` name leaves under the `chat.tool.crisis` copy
 * namespace; each consumer resolves them through its own copy mechanism.
 */
export const CRISIS_RESOURCE_ROWS = [
  {
    iconName: 'phone',
    iconTone: 'tan',
    labelKey: 'row911Label',
    descriptionKey: 'row911Description',
  },
  {
    iconName: 'message-outlined',
    iconTone: 'pink',
    labelKey: 'row988Label',
    descriptionKey: 'row988Description',
  },
  {
    iconName: 'heart',
    iconTone: 'yellow',
    labelKey: 'rowClinicianLabel',
    descriptionKey: 'rowClinicianDescription',
  },
] as const;

export type CrisisResourceRow = (typeof CRISIS_RESOURCE_ROWS)[number];
export type CrisisResourceCopyKey = CrisisResourceRow['labelKey' | 'descriptionKey'];
